import { CHECKBOX_ROLE } from '@wix/wix-data-client-common-standalone'

import { type CheckboxInputData } from '../types'
import {
  assertCheckboxInputData,
  assertNonNullable,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const addComponentForBooleanField: FieldComponentAdder = ({
  fieldKey,
  fieldName,
  page,
  templateComponentByVeloId,
  templateControllerConnectionsByVeloId,
}) =>
  addComponentForField({
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
    templateVeloId: 'booleanFieldTemplate',
    componentAdjustments: {
      modifyComponent: component => {
        assertNonNullable(component.data)
        assertCheckboxInputData(component.data)
        const data: CheckboxInputData = { ...component.data, label: fieldName }
        return { ...component, data }
      },
      connectionConfigModifierByRole: {
        [CHECKBOX_ROLE]: config =>
          setConnectionConfigPropertyField({
            config,
            propertyName: 'checked',
            fieldKey,
          }),
      },
      veloId: `${fieldKey}Field`,
    },
  })
